module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"No notifications yet","description":"This is where we\u0027ll keep all your notifications."}}')
  delete Component.options._Ctor
}
